import styled from 'styled-components';
import { beam } from '@styles/colors/themes';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';
import { DateInput } from '@components/index';

export const DateInputSmallGrey = styled(DateInput)`
  & .MuiInputBase-input {
    border-radius: 4px;
    border-color: transparent;
    color: ${COLORS_FLAT.n800};
    /* padding for shift-animation */
    padding-right: 0;
    padding-left: 0;
    cursor: pointer;

    ::placeholder {
      color: #c1c4d6;
      opacity: 1;
      font-style: italic;
    }

    :hover {
      background: ${beam.background.card};
      border-color: ${beam.background.card};
      padding-left: 8px;
      padding-right: 8px;
    }
  }
  &[data-active='true'] {
    & .MuiInputBase-input {
      background-color: #fff;
      border-color: #d8dae5;
      padding-left: 8px;
      padding-right: 8px;
    }
    &[data-error='true'] .MuiInputBase-input {
      border-color: ${COLORS_FLAT.r400};
    }
  }

  & .Mui-disabled {
    cursor: not-allowed;

    &.MuiIconButton-root,
    &.MuiInputBase-input {
      color: ${COLORS_FLAT.n800};
      border-color: transparent;
    }
    &.MuiInputBase-input {
      background-color: transparent;
      :hover {
        background-color: ${beam.background.card};
      }
    }
  }
`;
